import axios from 'axios';
import {LogFilters, LogPage, LogPageParams, LogRecord, LogsStats, UserLogReport} from './types';

async function request<T>(path: string, params: object = {}, signal?: AbortSignal): Promise<T> {
  const response = await axios.get(path, {params, signal, timeout: 60000});
  if (!response.data?.success) throw new Error(response.data?.error || 'Não foi possível carregar os logs.');
  return response.data;
}
export async function fetchLogs(params: LogPageParams, signal?: AbortSignal): Promise<LogPage<LogRecord>> {
  return request<LogPage<LogRecord>>('/logs', {...params, includeData: false}, signal);
}
export async function fetchLogStats(filters: LogFilters, signal?: AbortSignal): Promise<LogsStats> {
  return (await request<{data: LogsStats}>('/logs/stats', filters, signal)).data;
}
export async function fetchLogUsers(signal?: AbortSignal): Promise<{id_user: number | null; name: string}[]> {
  return (await request<{data: {id_user: number | null; name: string}[]}>('/logs/users', {}, signal)).data;
}
export async function fetchLogTypes(signal?: AbortSignal): Promise<{id_log_type: number; name: string}[]> {
  return (await request<{data: {id_log_type: number; name: string}[]}>('/logs/types', {}, signal)).data;
}
export async function fetchUserReport(params: LogPageParams, signal?: AbortSignal): Promise<LogPage<UserLogReport>> {
  return request<LogPage<UserLogReport>>('/logs/users-report', params, signal);
}
export async function fetchLogDetail(id: number, signal?: AbortSignal): Promise<LogRecord> {
  return (await request<{data: LogRecord}>('/logs/' + id, {}, signal)).data;
}

export const MAX_EXPORT_ROWS = 10000;
export async function collectExport<T>(
  fetchPage: (params: LogPageParams, signal?: AbortSignal) => Promise<LogPage<T>>,
  filters: LogFilters,
  signal: AbortSignal,
  onProgress: (count: number, total: number) => void,
  report = false
): Promise<T[]> {
  const rows: T[] = [];
  let page = 1;
  let maxId: number | undefined;
  let snapshot: string | undefined;
  let total = 0;
  do {
    if (signal.aborted) throw new Error('Exportação cancelada.');
    const result = await fetchPage({...filters, page, limit: 500, sortBy: report ? 'user' : 'id_log', sortOrder: 'ASC', maxId, ...(snapshot ? {snapshot} : {})}, signal);
    if (page === 1) {
      total = result.pagination.total;
      maxId = result.pagination.maxId ?? undefined;
      if (total > MAX_EXPORT_ROWS) throw new Error('O filtro contém mais de 10.000 registros. Reduza o período ou selecione um usuário para exportar.');
    }
    snapshot = result.pagination.snapshot;
    rows.push(...result.data);
    onProgress(rows.length, total);
    if (result.data.length === 0 || page >= result.pagination.totalPages) break;
    page++;
  } while (rows.length < total && rows.length <= MAX_EXPORT_ROWS);
  if (signal.aborted) throw new Error('Exportação cancelada.');
  if (rows.length !== total) throw new Error('Os registros foram alterados durante a exportação. Atualize a consulta e tente novamente.');
  return rows;
}
